'use strict';

module.exports = {
    SUBSCRIPTION_CREATED: 'subscription.created',
    SUBSCRIPTION_FAILED: 'subscription.failed'
};